import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(
        typeof detail === "string" ? detail : "Incorrect email or password."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a14] text-[#f4ede1] p-6">
      <div className="relative w-full max-w-md">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full bg-[#f5c76e]/[0.05] blur-3xl pointer-events-none" />
        <div className="relative bg-[#13121f] border border-white/10 rounded-2xl p-8 sm:p-10">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-2 h-2 rounded-full bg-[#f5c76e] shadow-[0_0_14px_rgba(245,199,110,.7)]" />
            <span className="font-display text-base font-bold tracking-tight">
              Warp Admin
            </span>
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight mt-6">
            Welcome back,
            <br />
            <span className="font-serif italic font-light text-[#f5c76e]" style={{ fontFamily: "Fraunces, serif" }}>
              Charlotte.
            </span>
          </h1>
          <p className="text-[#bdb6c4] text-sm mt-3">
            Sign in to mission control.
          </p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9c95a8] block mb-2">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full bg-[#0a0a14] border border-white/10 rounded-xl px-4 py-3 text-[#f4ede1] outline-none focus:border-[#f5c76e]/60 transition-colors"
                placeholder="charlotte@warpappdevelopment.com"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9c95a8] block mb-2">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full bg-[#0a0a14] border border-white/10 rounded-xl px-4 py-3 text-[#f4ede1] outline-none focus:border-[#f5c76e]/60 transition-colors"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="login-submit-button"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#f5c76e] text-[#0a0a14] font-semibold hover:bg-[#ffd485] transition-colors disabled:opacity-60"
            >
              {submitting ? "Signing in…" : "Sign in →"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
